import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
	selector: 'g-loading-spinner',
	templateUrl: './loading-spinner.component.html',
	styleUrls: ['./loading-spinner.component.scss'],
	standalone: false,
})
export class LoadingSpinnerComponent implements OnInit {
	@Input() readonly fixed: boolean;
	@HostBinding('class.is-fixed') isFixed: boolean;

	ngOnInit(): void {
		if (this.fixed) this.isFixed = true;
	}
}
